import { render, staticRenderFns } from "./BasicCheckbox.vue?vue&type=template&id=554b6052"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports